module.exports = __webpack_public_path__ + "img/lt_get.a97419b.png";